class ScrollProgress {
	constructor(el) {
		this.el = el
		this.track = this.el.querySelector('.scroll-progress__track')
		this.fill = this.el.querySelector('.scroll-progress__fill')

		jQuery(window).scroll(function() {
			let docHeight = Math.max( jQuery(document).height(), jQuery(window).height() )

			let elTop = this.el.offsetTop// - 50
			let elHeight = this.el.clientHeight
			let elBottom = elTop+elHeight
			let elBottomHeight = docHeight - elBottom
			let menuHeight = 69

			let pos = window.scrollY + 200

			let fraction = 100 - ((pos-elTop)/elHeight)*100;

			this.fill.setAttribute('style','bottom:'+fraction+'%;');
			if (pos > elTop + menuHeight && pos < elBottom + menuHeight) {
				// console.log("fraction",fraction)
				this.el.classList.add('is-active')
			}
			else {
				this.el.classList.remove('is-active')
			}
		}.bind(this));
	}
}

export default ScrollProgress
